import configdata from "../../config.json";
import { userSliceAction } from "./UserSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllUserItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi("get", `${configdata.SERVER_URL}/api/users`);
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(userSliceAction.getAllUser(res.data.users));
  };
};
export const createUserItem = (data) => {
  return async (dispatch) => {
    const { form } = getOnlyValueFromSelectObject(data);
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/users/store`,
      form
    );
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          userSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(userSliceAction.setInitialData());
    dispatch(
      userSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));

    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllUserItems());
  };
};
export const getDataForEdit = (id, factoryList) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/users/edit/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.user[0] };

    const factory = factoryList.find((item) => {
      return item.value === data.factory_id;
    });
    data.role = {
      value: `${data.role}`,
      label: data.role === "super_admin" ? "Super Admin" : "Factory Admin",
      type: "role",
    };
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };

    data.factory = {
      value: factory.value,
      label: factory.label,
      type: factory.type,
    };
    dispatch(userSliceAction.getUserDataEdit(data));
  };
};

export const updateUserItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/users/update/${data.id}`,
      form
    );
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          userSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      userSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(userSliceAction.setInitialData());
    dispatch(appLevelSliceActions.setIsSuccess(true));

    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllUserItems());
  };
};

export const deleteUserItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi("get", `${configdata.SERVER_URL}/api/users/delete/${id}`);
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
